var render = function render(){var _vm=this,_c=_vm._self._c;return _c('adaptive-modal',{attrs:{"name":"email-modal","hide-action-buttons":true,"width":"800"},on:{"before-open":_vm.beforeOpen}},[(_vm.email)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.email.body)}}):_c('div',[_vm._v("Laddar mail...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }